export interface ProductTypeCandidate {
  id: string;
  kind: string;
  type?: string | null;
}

/** Regular products must have a real business type before Costs. A null type
 * must never silently mean physical because that asks the wrong questions for
 * software, courses, memberships, and services. */
export function untypedRegularProductIds(products: readonly ProductTypeCandidate[]): string[] {
  return products
    .filter((product) => product.kind === "product" && !product.type)
    .map((product) => product.id)
    .sort();
}
